import React from 'react';
import clsx from 'clsx';
import CompositeImage from '../CompositeImage/CompositeImage';

type Props = {
  src?: string;
  size?: React.CSSProperties['width'];
  containerClassName?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
  ref?: React.LegacyRef<HTMLDivElement>;
};

const KaleidoAvatar: React.FC<Props> = ({ containerClassName, className, src, size, ...rest }) => (
  <div className={clsx(containerClassName, className)} {...rest}>
    <CompositeImage.SimpleProfilePicture src={src} size={size} />
  </div>
);

export default KaleidoAvatar;
